import { useCallback, useEffect, useRef, useState } from "react";
import { isRequestCancellation } from "@shared/api/client";
import { getItData } from "../api/it";
import type { ItIncident, ItMeta } from "../types/it";

const emptyMeta: ItMeta = {
  current_user: {
    id: 0,
    nombre: "Usuario",
    correo: "",
    rol: "empleado",
  },
  users: [],
  technicians: [],
  projects: [],
  categories: [],
  permissions: {
    can_create: false,
    can_reorder: false,
  },
};

export function useIt() {
  const [incidents, setIncidents] = useState<ItIncident[]>([]);
  const [meta, setMeta] = useState<ItMeta>(emptyMeta);
  const [loading, setLoading] = useState(true);
  const mountedRef = useRef(true);

  const reload = useCallback(async () => {
    setLoading(true);

    try {
      const response = await getItData();

      if (!mountedRef.current) return;

      setIncidents(response.data);
      setMeta(response.meta);
    } catch (error) {
      if (!isRequestCancellation(error)) {
        console.error("Error cargando IT", error);
      }
    } finally {
      if (mountedRef.current) {
        setLoading(false);
      }
    }
  }, []);

  useEffect(() => {
    mountedRef.current = true;
    void reload();

    return () => {
      mountedRef.current = false;
    };
  }, [reload]);

  const replaceIncident = useCallback((incident: ItIncident) => {
    setIncidents((current) => {
      const index = current.findIndex((item) => item.id === incident.id);

      if (index === -1) {
        return [incident, ...current];
      }

      const next = [...current];
      next[index] = incident;
      return next;
    });
  }, []);

  return {
    incidents,
    meta,
    loading,
    reload,
    setIncidents,
    replaceIncident,
  };
}
